import { css } from 'styled-components'

const lstPxs = [60, 180, 120, 180, 180, 120, 200, 200, 200]
const sumPx = lstPxs.reduce((total, curr) => total + curr)
const gridArr = lstPxs.map(item => `minmax(${item}px, ${Math.round((item / sumPx) * 100)}fr)`)

const extendStylesTable = css`
    .header, .row {
        grid-template-columns: ${gridArr.join(" ")}
    }
`;

const extendStylesHeadStaff = css`
    width: 220px;
`

export {
    extendStylesTable,
	extendStylesHeadStaff
}